<template>
  <div class="net-work" :style="getWorkStyle">
    <div class="net-work-panel net-work-top" :class="{ 'net-work-top-4-column': column === 5 }"></div>
    <div class="net-work-face" :style="getFaceStyle">
      <el-scrollbar ref="view" :key="list" style="height: 100%;position: inherit;" :class="{ 'el-scrollbar-wrap-hide-scroll': isSpecial(1) === 'half-slot' }">
        <div class="flex-layout" :class="{ 'slot-work-face': isSpecial() === 'all-slot' }">
          <div v-if="model === 'M4350-16M4V'" class="panel-label">F</div>
          <div v-if="model === 'M4350-16M4V'" class="panel-label panel-label-back">B</div>

          <slot-panel
            v-for="(item, index) in list"
            :key="item.id"
            :item="item"
            :isSpecial="isSpecial(index)"
            style="width: 100%;"
          >
          <component
              :is="mode"
              :popover="popover"
              :value="value"
              :multiple="multiple"
              :isEnabled="isEnabled"
              :isEnabledTu="isEnabledTu"
              ref="panelRef"
              :list="item.port.filter(obj => obj.rootPortNum === undefined)"
              :fanout="item.port.filter(obj => obj.rootPortNum !== undefined)"
              @change="lanChangeHandler"
              :slotId="item.model"
            />
          </slot-panel>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, provide, onMounted, watch, getCurrentInstance, toRefs } from 'vue'
import { storeToRefs } from 'pinia'
import { useNetworksStore, useDeviceStore, useMainStore } from '@/stores'
import oneRowPanel from './one-row-panel.vue'
import twoRowPanel from './two-row-panel.vue'
import fourRowPanel from './four-row-panel.vue'
import largeRowPanel from './panel-96.vue'
import frontBackPanel from './front-back-panel.vue'
import slotPanel from './slot-panel.vue'
import { PORT_TYPE_MAP } from '@/const/enum.js'

const props = defineProps({
  popover: {
    type: Boolean,
    default: false
  },
  value: {
    type: Array,
    default: () => [],
  },
  multiple: {
    type: Boolean,
    default: true,
  },
  isEnabled: {
    type: Boolean,
    default: true,
  },
  isEnabledTu: {
    type: Boolean,
    default: false
  },
  enabledDetach: {
    type: Boolean,
    default: false
  },
  portInterfaceList: {
    type: Array,
    default: () => [],
  },
   keepSelected: {
    type: Boolean,
    default: false,
  },
  isUpdatePanel: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['mounted', 'update-active','update:modelValue', 'input', 'change'])
const panelRef = ref(null)
const networksStore = useNetworksStore()
const deviceStore = useDeviceStore();
const mainStore = useMainStore();
// const { getInitNetwork, getPortList } = storeToRefs(networksStore)
// const { getDeviceInfo, getUnit, getUnitModel, getUnitList } = storeToRefs(deviceStore);
const getDeviceInfo = ref(deviceStore.deviceInfo);
// const getInitNetwork = ref(networksStore.initNetwork);

const { proxy, instance } = getCurrentInstance();
const { value, portInterfaceList, multiple } = toRefs(props);

const list = ref([])
const mode = ref('')
const column = ref(1)
const tu = ref(0)
const selectMap = reactive(new Map())
const tuMap = reactive(new Map())
const allList = reactive(new Map())
const unitSelectMap = reactive(new Map())
const dialogModel = ref('')
const tempUnitId = ref('')
const portInterfaceMap = reactive(new Map())
const fanoutNum = ref('');

const initNetwork = ref([]);
const deviceInfo = computed(() => deviceStore.deviceInfo)
const slotId = computed(() => mainStore.unit)
const model = computed(() => mainStore.unitModel)
const portList = computed(() => networksStore.portList)
const unit = computed(() => mainStore.unit)
const unitList = computed(() => mainStore.unitList)

const view = ref(null)
// provide('network', { list })

const getWorkStyle = computed(() => {
  const obj = { height: `${(50 * column.value) + 12}px`, backgroundColor: '#fff' }
  if (isSpecial()) {
    obj.width = 'inherit'
    obj.perspective = '280px'
  }
  if(model.value === 'M4350-16M4V'){
    obj.width = '100%'
  }
  return obj
})

const getFaceStyle = computed(() => ({ height: `${50 * column.value + 8}px` }))

const querySlot = computed(() => {
  const one = initNetwork.value.find(item => item.id == mainStore.unit)
  return one ? one.slot : []
})

const baseInfo = computed(() => {
  const details = getDeviceInfo.value.details
  if (!details) return []
  return details.find(item => item.unit == mainStore.unit) || {}
})

const queryModel = computed(() => dialogModel.value || mainStore.unitModel);

const isSpecial=(index)=> {
  if(queryModel.value.toUpperCase() === 'M4300-96X'){
    return 'all-slot';
  } else if(queryModel.value.toUpperCase() === 'M4350-16M4V' && index === 1){
    return 'half-slot';
  } else {
    return false
  }
}

const updateInterfaceMap = () => {
  props.portInterfaceList.forEach(item => {
    portInterfaceMap.set(item.portNum, item)
  })
}

const preDealData = (list, model) => {
  const arr = [1,2,3,4,5,6,7,8,9,10,11,12];
  list = proxy.$sakura.deepCopy(list || querySlot.value)
  if (model.toUpperCase() === 'M4300-96X') {
    list = arr.map(item => list.find(obj => obj.id == item) || { id: item, model: '', port: [] })
  }
  return list
}

const init = () => {

  mainStore.unitList.forEach(item => {
    const lis = initListItems(querySlotById(item.unit), item.model, item.unit);
    allList.set(item.unit, lis)
    unitSelectMap.set(item.unit, props.isEnabledTu ? 0 : false)
  })
  initList()
}

const initList = (slotId, model) => {
  if (!slotId) slotId = mainStore.unit
  if (!slotId) model = mainStore.unitModel
  else tempUnitId.value = slotId

  dialogModel.value = model;

  list.value = allList.get(slotId) || []
  if (!props.multiple) updateHandler()
  modelByPanel();
  emit('mounted', list.value)
  setTimeout(() => view.value?.update?.(), 0)
  return queryUnitSelect()
}

const createItems = (listData, unit, childs = []) => {
  return listData.map(item => {
    const _all = allList
      ?.get(unit)
      ?.flatMap(row => row.port || [])

    const isRowSelected = _all?.find(data => {
      return data.portNum === item.portNum
    });

    const _list = list.value?.flatMap(row => row.port || [])

    const isTuBackup = _list?.find(data => {
      return data.portNum === item.portNum
    });

    let isSelected = (props.keepSelected) ? (isRowSelected?.selected || false) : false;
    let tuBackup = isTuBackup;
    let tuCopy = proxy.$sakura.deepCopy(tu.value);

    let obj = Object.assign(Object.create({}, {
      _isEnabled: { value: props.isEnabled, enumerable: false },
  _isEnabledTu: { value: props.isEnabledTu, enumerable: false },
  _enabledDetach: { value: props.enabledDetach, enumerable: false }
        }), {
          unit,
          value: item.id,
          hex: '',
          mode: [],
          status: '',
          lag: '',
          tu: (props.isEnabledTu) ? (tuBackup && tuBackup?.tu) || 0 : tuCopy,
          portNum: item.portNum,
          selected: Boolean(isSelected) || false,
          priority: [],
          borderStatus: '',
          isEnabled: props.isEnabled,
          isEnabledTu: props.isEnabledTu,
          detach: item.linkState == 2,
          type: PORT_TYPE_MAP[item.moduleType],
          detect: item.detect,
          config: {},
          rootPortNum: item.rootPortNum,
          fanout: childs.includes(item.portNum)
        });
        return obj;
      });
}

const selectAll = () => {
  if (multiple.value) {
    updateIterator((item) => {
      if (item.isEnabled && !item.fanout) item.selected = true;
      return item;
    });
    unitSelectMap.set(dialogModel.value ? tempUnitId.value : slotId.value, true);
  }
};

const unselectAll = () => {
  if (multiple.value) {
    updateIterator((item) => {
      item.selected = false;
      return item;
    });
    unitSelectMap.set(dialogModel.value ? tempUnitId.value : slotId.value, false);
  }
};

const clearAllColor = () => {
  updateIterator((item) => {
    item.hex = '';
    return item;
  });
};

const clearSelect = () => {
  updateIterator((item) => {
    item.selected = false;
    return item;
  });
  unitSelectMap.set(dialogModel.value ? tempUnitId.value : slotId.value, false);
};

const switchAllTu = () => {
  if (props.isEnabledTu) {
    const key = dialogModel.value ? tempUnitId.value : slotId.value;
    const old = unitSelectMap.get(key);
    if (old !== undefined) tu.value = old;
    tu.value++;
    if (tu.value > 2) tu.value = 0;
    updateIterator((item) => {
      if (!item.fanout) item.tu = tu.value;
      return item;
    });
    unitSelectMap.set(key, tu.value);
    return tu.value;
  }
};

const lanChangeHandler = (value, obj) => {
  if (multiple.value) {
    updateIterator((item) => {
      if (obj.portNum === item.portNum) item.selected = value;
      return item;
    });
  } else {
    clearSelect();
    updateIterator((item) => {
      if (obj.portNum === item.portNum) item.selected = value;
      return item;
    });
    updateHandler(); // Assume this is defined elsewhere
  }
};



const initListItems = (list, model, unit) => {
  return preDealData(list, model).map(info => {
    const fanout = info.fanout || []
    const child = fanout.map(item => item.rootPortNum)
    info.port = createItems(info.port, unit, [...new Set(child)]);
    if (fanout.length) {
      info.port = info.port.concat(createItems(fanout, unit))
    }
    info.fanout = fanout
    return info
  })
}
// Pinia state
// const unitList = computed(() => mainStore.unitList);



const querySlotById = (slotId) => {
  const one = initNetwork.value.find(item => item.id == slotId)
  return one ? one.slot : []
}



const updateHandler = () => {
  emit('update:modelValue', list.value); // or this.list if not using <script setup>
  emit('change', list.value);
}

const modePanelData = {
  oneRowPanel,
  twoRowPanel,
  fourRowPanel,
  largeRowPanel,
  frontBackPanel
}

const modelByPanel = () => {
  let model = baseInfo.value.model || ''
  if (queryModel.value) model = queryModel.value
  const result = proxy.$sakura.initNetworkColumn(model)
  if (result.column) column.value = result.column
  // if (result.mode) mode.value = modePanelData['largeRowPanel']
  if (result.mode) mode.value = modePanelData[result.mode]

}

const queryUnitSelect = () => {
  return unitSelectMap.get(dialogModel.value ? tempUnitId.value : mainStore.unit)
}

const updateUnitSelect = () => {
  let current = queryUnitSelect(); // assume this is a method defined in setup
  let val = current;

  // Flatten the nested port lists
  let listData = list.value.map(item => item.port).reduce((a, b) => a.concat(b), []);

  if (props.isEnabledTu) {
    const enabledTus = listData.filter(item => item.isEnabledTu).map(item => item.tu);
    const isEqual = [...new Set(enabledTus)].length === 1;

    if (!isEqual) {
      val = 0;
    } else {
      const [one] = listData.filter(item => item.isEnabledTu);
      if (one) val = one.tu;
    }
  } else {
    const selectedFlags = [...new Set(listData.filter(item => item.isEnabled).map(item => item.selected))];
    const isEqual = selectedFlags.length === 1 && selectedFlags[0] === true;

    val = isEqual ? true : false;
  }

  unitSelectMap.set(dialogModel.value ? tempUnitId.value : slotId.value, val);
  emit('update-active', queryUnitSelect());
};


const updateIterator = (callback, li) => {
      let listNew = li || list.value;
      listNew = listNew.map((item, idx) => {
        item.port = item.port.map((obj, index) => {
          if (callback && !obj.fanout) {
            let data = callback(obj, index, item, idx);
            if (data) obj = data;
            updateMap(data)
          }
          return obj;
        });
        return item;
      });

    };

const portListIterator = (callback) => {
      //port循环
      portList.value.forEach(obj => {
        updateIterator((obj1) => {
          if (callback) {
            let data = callback(obj1, obj);
            if (data) obj1 = data;
          }
          return obj1;
        });
      })
    };

    const queryPortList = (list) => {
  const li = proxy.$sakura.deepCopy(list).map(item => item.port);
  if (li.length === 0) return [];
  return li.reduce((a, b) => [...a, ...b]);
};

const updateMap = (item) => {
      let { portNum, isEnabledTu, selected } = item;
      if (isEnabledTu) {
        tuMap.set(portNum, item);
      } else {
        if (selected) {
          selectMap.set(portNum, item);
        } else selectMap.delete(portNum);
      }
    };

    const listIterator = (callback, li = list.value) => {
  proxy.$sakura.deepCopy(li).forEach((item, idx) => {
    item.port.forEach((obj, index) => {
      if (callback) callback(obj, index, item, idx);
    });
  });
};

// listFilter (Port Filter)
const listFilter = (callback) => {
  return proxy.$sakura.deepCopy(list.value)
    .filter(item => {
      const filteredPorts = item.port.filter((obj, index) => callback(obj, index));
      item.port = filteredPorts;
      return !!filteredPorts.length;
    });
};


// updateAllIterator
const updateAllIterator = (callback) => {
  allList.forEach((node) => {
    node.map((item, idx) => {
      item.port = item.port.map((obj, index) => {
        if (callback && !obj.fanout) {
          const data = callback(obj, index, item, idx);

          if (data) {
            obj = data;
            updateMap(data); // make sure updateMap() is defined
          }
        }
        return obj;
      });
      return item;
    });
  });
};

const querySelectList = () => {
  const arr = [];
  const mapToUse = props.isEnabledTu ? tuMap : selectMap;

  // ✅ Guard clause to prevent undefined errors
  if (mapToUse && typeof mapToUse.forEach === 'function') {
    mapToUse.forEach((node) => arr.push(node));
  }
  return arr;
};

// 🟡 1. Watch list
watch(list, () => {
  if (multiple.value) updateHandler();
}, { deep: true, immediate: true },);

// 🟡 2. Watch value
watch(value, (newValue) => {
  let tempId = tempUnitId.value;
  list.value = newValue;
  if (!tempId) tempId = slotId.value;
  allList.set(tempId, newValue);
}, { deep: true });

let panelUpdatedTimes = 0;
watch(
  () => networksStore.initNetwork,
  (newVal) => {
    if(!props.isUpdatePanel && panelUpdatedTimes >= 1) return;
      initNetwork.value = JSON.parse(JSON.stringify(newVal));
      init();
      panelUpdatedTimes++;
  },
  { immediate: true, deep: true }
)

// 🟡 4. Watch deviceInfo
watch(deviceInfo, () => {
  modelByPanel();
}, { deep: true });

// 🟡 5. Watch portInterfaceList
watch(portInterfaceList, (val) => {
  updateInterfaceMap();
}, { deep: true, immediate: true });



onMounted(async() => {
  await updateInterfaceMap();

  if (!networksStore.portList || Object.keys(networksStore.portList).length === 0) {
      await networksStore.queryPortList({ portid: 'all' });
    }

  await init()

})

defineExpose({
  // Expose lifecycle methods
  init,
  initList,

  // Selection logic
  selectAll,
  unselectAll,
  clearSelect,
  clearAllColor,
  switchAllTu,

  // Slot handling
  lanChangeHandler,
  updateIterator,
  portListIterator,
  querySelectList,
  updateUnitSelect,
  queryPortList,
  listIterator, listFilter, updateAllIterator,

  // Useful states (if needed by parent)
  list,
  portList,
  model,
  slotId,
  unitSelectMap,
  portInterfaceMap,
  mode,
  column,
  tu,
  dialogModel,
  tempUnitId,
  fanoutNum,

  // Utility function
  updateHandler,
})
provide('network', {
  selectAll,
  clearSelect,
  updateIterator,
  updateUnitSelect,
  querySelectList,
  portInterfaceMap,
  clearAllColor
});

</script>

<style lang="scss" scoped>
@use "@/css/base.scss" as *;

$one-row-height: 50px;

.net-work {
  position: relative;
  width: 940px;
  perspective: 200px;
  padding-top: 11px;
  height: 12px + $one-row-height;
  perspective-origin: center center;
  transform: translate3d(0, 0, 0);

  .net-work-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: absolute;
    backface-visibility: inherit;
    color: #fff;
    background-color: #F5F8F9;
    border: 1px solid $network-border-color;
  }

  .net-work-top {
    transform: rotateX(38deg);
    position: absolute;
    height: 16px;
    margin-top: -13px;
    width: calc(100% - 20px);
    margin-left: 10px;
    border: 1px solid #2c262d;
    background: linear-gradient(180deg, #504b51, #2c262d);
  }

  .net-work-top-4-column {
    margin-top: -11px;
    width: calc(100% - 26px);
    margin-left: 14px;
  }

  .net-work-face {
    height: 50px;
    color: $color-default;
    border-right: none;
    margin-top: -8px;

    ::v-deep(.slot-box) {
      background: linear-gradient(180deg, #3f3d40, #2c262d);
    }

    ::v-deep(.net-work-row) {
      min-width: fit-content;
    }

    ::v-deep(.el-scrollbar) {
      margin-bottom: 10px;

      .el-scrollbar__wrap {
        height: auto;

        .el-scrollbar__view {
          border-top: 8px solid transparent;
        }
      }

      &.el-scrollbar-wrap-hide-scroll .el-scrollbar__wrap {
        overflow: hidden;
        margin-right: 0 !important;
      }

      .el-scrollbar__bar {
        bottom: -10px;
        opacity: 1;
      }
    }

    .slot-work-face {
      width: 1345px;
      flex-wrap: wrap;
    }

    .panel-label {
      background: #3F3C40;
      font-size: 14px;
      color: #cccccc;
      padding: 4px;
      border-bottom: 1px solid #000;
    }

    .panel-label-back {
      position: absolute;
      top: 90px;
    }
  }
}
</style>
